import { render, staticRenderFns } from "./VEmployeeProfileDocuments.vue?vue&type=template&id=ace8ba00&lang=pug"
import script from "./VEmployeeProfileDocuments.vue?vue&type=script&lang=ts"
export * from "./VEmployeeProfileDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports